/**
 * Dates the way the house style writes them: day name, day number, month,
 * no ordinal. "Mon 21 Sep" where space is tight, "Monday 21 September" in a
 * sentence.
 *
 * Reads the value as its UTC calendar day. Prism sends dates as plain
 * `YYYY-MM-DD` or a midnight UTC stamp; rendering either in the browser's
 * zone would slip a day for anyone west of Greenwich.
 *
 * Names are spelled out here rather than read from Intl: the en-GB locale
 * data abbreviates September as "Sept" on newer ICU builds and "Sep" on
 * older ones, so the same value would render differently between a dev
 * machine and the Pages build.
 */
const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function formatDayDate(value, { long = false } = {}) {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    const weekday = WEEKDAYS[date.getUTCDay()];
    const month = MONTHS[date.getUTCMonth()];
    const day = date.getUTCDate();
    return long
        ? `${weekday} ${day} ${month}`
        : `${weekday.slice(0, 3)} ${day} ${month.slice(0, 3)}`;
}
